import React from "react";
import PropTypes from "prop-types";
import { Select3, Form } from "@weezevent/nacre";
import {
	ATTENDEE_ENTRY_TYPE,
	BUYER_ENTRY_TYPE
} from "../../../../models/forms-with-entry-usage";

const FormSelector = ({
	attendeeForms,
	buyerForms,
	selectedFormId,
	selectedEntryType,
	onChange,
	t
}) => {
	const formOptions = React.useMemo(() => {
		const buildFormOption = (form, category, entryType) => ({
			value: `${form.getFormPk()}-${entryType}`,
			text: `${form.getFormName()}${
				form.getEventName() ? ` (${form.getEventName()})` : ""
			}`,
			category: [category],
			formId: String(form.getFormPk()),
			entryType: entryType
		});

		return [
			...attendeeForms.map(form =>
				buildFormOption(
					form,
					t(
						"access.attendees.attendeesList.filters.formFields.attendeeForms"
					),
					ATTENDEE_ENTRY_TYPE
				)
			),
			...buyerForms.map(form =>
				buildFormOption(
					form,
					t(
						"access.attendees.attendeesList.filters.formFields.buyerForms"
					),
					BUYER_ENTRY_TYPE
				)
			)
		];
	}, [attendeeForms, buyerForms, t]);

	const handleSelectChange = combinedValue => {
		const option = formOptions.find(opt => opt.value === combinedValue);
		if (option) {
			onChange(option.formId, option.entryType);
		} else {
			onChange(null, null);
		}
	};

	return (
		<Form.Field>
			<Form.Label>
				{t("access.attendees.attendeesList.filters.formFields.form")}
			</Form.Label>
			<Select3
				options={formOptions}
				value={
					selectedFormId
						? `${selectedFormId}-${selectedEntryType}`
						: ""
				}
				onChange={handleSelectChange}
				placeholder={t(
					"access.attendees.attendeesList.filters.formFields.selectForm"
				)}
			/>
		</Form.Field>
	);
};

FormSelector.propTypes = {
	attendeeForms: PropTypes.array.isRequired,
	buyerForms: PropTypes.array.isRequired,
	selectedFormId: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	t: PropTypes.func.isRequired
};

export default FormSelector;
